import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import configureT from '../configureT';
import logo from '../../assets/img/airrefund.png';
import Spinner from '../Spinner';
import PropTypes from 'prop-types';
import LoaLawyerRouter from './LoaLawyerRouter';
import Cache from '../../utils/cache';
import Message from '../Message';
import _ from 'lodash';
import T from 'i18n-react';
import ProgressBar from '../ProgressBar';
import { isAbove18years } from '../../utils/loaLawyerHelpers';

class LoaLawyerContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paxData: {
        firstName: '',
        lastName: '',
        birthDate: '',
        birthPlace: '',
        street: '',
        postalCode: '',
        city: '',
        country: '',
        profession: '',
      },
      guardianData: {
        firstName: '',
        lastName: '',
        birthDate: '',
        birthPlace: '',
        street: '',
        postalCode: '',
        city: '',
        country: '',
        profession: '',
      },
      paxAdult: undefined,
      currentStage: this.stages[0],
    };
    this.cache = new Cache();
    this.configureLanguage()
  }

  stages = [
    'PassengerGuardianStage',
    'DocumentPreviewStage',
    'SignDocumentStage',
  ];

  componentDidMount = () => {
    const { location, match: {params: id} } = this.props;
    this.setCurrentStage(location.pathname);
    const guardianData = this.cache.loadGuardian(id);
    if (guardianData) {
      this.setState({ guardianData });
    }
  };

  handleErrors = () => {
    const { loaLawyer, history, match } = this.props;
    const id = match.params.id;
    const errorMessage = _.get(
      loaLawyer,
      'error.networkError.result.message',
      '',
    );
    if (errorMessage === 'LoaLawyers::Service::LoaLawyerSigned') {
      return this.setState({error: 'docSigned'})
    }
    if (errorMessage === 'LoaLawyers::Service::LoaLawyerExists') {
      history.push(`/loa-lawyer/${id}/sign`);
    } else {
      this.setState({
        error: 'serverError',
      });
    }
  };

  setPaxFromCache = ({cachedPaxData, disablePaxName, disablePaxDate}) => {
    this.setState({
      paxData: cachedPaxData,
      paxAdult: isAbove18years(cachedPaxData.birthDate),
      disablePaxName,
      disablePaxDate
    });
  };

  setPaxFromServer = () => {
    const { loaLawyer } = this.props;
    const { loaLawyerDocumentData } = loaLawyer;
    const {
      birthDate,
      firstName,
      lastName,
      ...otherPaxData
    } = loaLawyerDocumentData.passengerTicket;
    const disablePaxDate = birthDate && isAbove18years(birthDate)
    this.setState({
      paxData: {
        birthDate,
        firstName,
        lastName,
        ...otherPaxData
      },
      paxAdult: isAbove18years(birthDate),
      disablePaxDate,
      disablePaxName: Boolean(firstName && lastName),
    });
  };

  redirectToDocument = () => {
    const { match, history } = this.props;
    const id = match.params.id;
    history.push(`/loa-lawyer/${id}/sign`);
  };

  configureLanguage = passengerTicket => {
    const language = passengerTicket && passengerTicket.passengerLanguage;
    configureT(language, 'loaLawyer');
  };

  setCurrentStage = pathname => {
    let currentStage;
    currentStage = this.stages[0];
    if (pathname.includes('preview')) {
      currentStage = this.stages[1];
    }
    if (pathname.includes('sign')) {
      currentStage = this.stages[2];
    }
    this.setState({ currentStage });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { loaLawyer, generatedDocument, location, match } = this.props;
    const {
      loaLawyer: prevLoaLawyer,
      generatedDocument: prevGeneratedDocument,
      location: prevLocation,
    } = prevProps;
    const { prevLoaLawyerDocumentData = {} } = prevLoaLawyer;
    const { loaLawyerDocumentData = {} } = loaLawyer;
    const documentExists =
      generatedDocument.loaLawyer && generatedDocument.loaLawyer.documentUrl;
    const isSigned = _.get(generatedDocument, 'loaLawyer.isSigned', false)
    const prevIsSigned = _.get(prevGeneratedDocument, 'loaLawyer.isSigned', false)
    const prevLawFirm = _.get(prevLoaLawyerDocumentData, 'lawFirm.id')
    const lawFirm = _.get(loaLawyerDocumentData, 'lawFirm.id')
    const lawFirmChanged = lawFirm !== prevLawFirm
    const id = match.params.id;

    if (
      !prevLoaLawyerDocumentData.passengerTicket &&
      loaLawyerDocumentData.passengerTicket
    ) {
      this.configureLanguage(loaLawyerDocumentData.passengerTicket);
    }

    if (!prevGeneratedDocument.loaLawyer && documentExists && !lawFirmChanged) {
      this.redirectToDocument();
    }
    if(!prevIsSigned && isSigned) {
      this.setState({error: 'serverError'});
    }

    if (!prevProps.loaLawyer.error && loaLawyer.error) {
      this.handleErrors();
    }

    if (
      !prevProps.loaLawyer.loaLawyerDocumentData &&
      this.props.loaLawyer.loaLawyerDocumentData
    ) {
      const cachedPaxData = this.cache.loadPax(id);
      const {birthDate, firstName, lastName} = loaLawyerDocumentData.passengerTicket;
      const disablePaxName = Boolean(firstName && lastName)
      const disablePaxDate = birthDate && isAbove18years(birthDate)
      if (cachedPaxData) {
        this.setPaxFromCache({cachedPaxData, disablePaxName, disablePaxDate});
      } else {
        this.setPaxFromServer();
      }
    }
    if (prevLocation.pathname !== location.pathname) {
      this.setCurrentStage(location.pathname);
    }
  };

  onPaxFormSubmit = paxData => {
    const { match, history } = this.props;
    const id = match.params.id;
    const paxAdult = isAbove18years(paxData.birthDate);
    this.cache.savePax(id, paxData);
    this.setState({ paxData, paxAdult });
    paxAdult
      ? history.push(`/loa-lawyer/${id}/preview`)
      : history.push(`/loa-lawyer/${id}/guardian`);
  };

  onGuardianFormSubmit = guardianData => {
    const { match, history } = this.props;
    const id = match.params.id;
    this.cache.saveGuardian(id, guardianData);
    this.setState({ guardianData });
    history.push(`/loa-lawyer/${id}/preview`);
  };

  onPrevStage = () => {
    const { match, history } = this.props;
    const id = match.params.id;
    history.push(`/loa-lawyer/${id}`);
  }

  render() {
    const { loaLawyer = {}, isSubmitting, match, countries } = this.props;
    const { paxData, guardianData, error, disablePaxName, disablePaxDate } = this.state;
    const { allCountries = [] } = countries;
    const { loaLawyerDocumentData = {} } = loaLawyer;
    const loading = countries.loading || loaLawyerDocumentData.loading;
    const isLoading = loading || isSubmitting;
    const id = match.params.id;
    const {firstName, lastName} = paxData
    const paxDisplayName = firstName && '- ' +  firstName + " " + lastName

    if (error) {
      const isApproved = ['docSigned'].includes(error)
      return Message(T.translate(error), isApproved)
    }

    return (
      <div className="loa2 site-template">
        <header className="header">
          <img src={logo} alt="airrefund logo" />
        </header>
        {isLoading ? (
          <Spinner />
        ) : (
          <LoaLawyerRouter
            disablePaxName={disablePaxName}
            disablePaxDate={disablePaxDate}
            allCountries={allCountries}
            onPaxFormSubmit={this.onPaxFormSubmit}
            onGuardianFormSubmit={this.onGuardianFormSubmit}
            onPrevStage={this.onPrevStage}
            paxData={paxData}
            paxDisplayName={paxDisplayName}
            paxAdult={this.state.paxAdult}
            guardianData={guardianData}
            id={id}
            progressBar={
              <ProgressBar
                stages={this.stages}
                currentStage={this.state.currentStage}
              />
            }
            {...this.props}
          />
        )}
      </div>
    );
  }
}

const Countries = gql`
  query {
    allCountries
  }
`;

const LoaLawyerDocumentData = gql`
  query LoaLawyerDocumentData($token: String!) {
    loaLawyerDocumentData(token: $token) {
      passengerTicket {
        passengerLanguage
        firstName: passengerFirstName
        lastName: passengerLastName
        birthDate: dateOfBirth
        birthPlace: placeOfBirth
        profession
        street
        postalCode: postCode
        city
        country
      }
      lawFirm {
        id
        name
        city
        country
        street
      }
      airline {
        name
      }
    }
  }
`;

const generatedDocument = gql`
  query loaLawyer($token: String!) {
    loaLawyer(token: $token) {
      id
      documentUrl
      isSigned
    }
  }
`;

LoaLawyerRouter.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default compose(
  graphql(Countries, {
    name: 'countries',
    props: ({ countries }) => {
      const allCountries = countries.allCountries;
      if (allCountries) {
        const transformedCountries = allCountries.map(country => ({
          label: country[0],
          value: country[1],
        }));
        return {
          countries: {
            ...countries,
            allCountries: transformedCountries,
          },
        };
      }
      return { countries };
    },
  }),
  graphql(generatedDocument, {
    name: 'generatedDocument',
    options: props => {
      const token = props.match.params.id;
      return {
        variables: { token },
      };
    },
  }),
  graphql(LoaLawyerDocumentData, {
    name: 'loaLawyer',
    options: props => {
      const token = props.match.params.id;
      return { variables: { token } };
    },
  }),
)(LoaLawyerContainer);



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/index.js